import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link } from "react-router-dom";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import HostelHeader from "../HostelHeader";
import Nav from "../../master/NavBar";
import WelcomeBar from "../WelcomeBar";
import {
  attendanceAdd,
  todayAttendance,
} from "../../../api/HostelStudentAttendance";
import { formatToDate } from "../../master/FormatToDateTime";
import usePrivateLink from "../../config/usePrivateLink";

export default function HostelStudentAttendance() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [hostel_id, setHostelId] = useState(localStorage.getItem("hostel_id"));

  const getStaffList = async () => {
    setLoading(true);
    try {
      let addUrl = "";

      if (date) {
        addUrl += `&date=${date}`;
      }
      if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;

      const response = await todayAttendance(addUrl);
      if (response?.data?.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStaffList();
  }, [date]);

  const [ip, setIp] = useState(null);
  const [location, setLocation] = useState(null);

  useEffect(() => {
    const getIP = async () => {
      try {
        const response = await axios.get("https://api64.ipify.org?format=json");
        if (response.data) {
          setIp(response.data.ip);
        }
      } catch (error) {
        console.error("Failed to get IP:", error);
      }
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation(
            JSON.stringify({
              lat: position.coords.latitude,
              lon: position.coords.longitude,
            }),
          );
        },
        (error) => console.error("Error getting location:", error),
        { enableHighAccuracy: true },
      );
    }

    getIP();
  }, []);

  const handleAttendance = async (registration_no, datetime = null) => {
    setLoading(true);
    try {
      let formData = new FormData();
      formData.append("registration_no", registration_no);
      formData.append("ip", ip);
      formData.append("checked_by", location);
      formData.append("datetime", datetime);
      const response = await attendanceAdd(formData);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
      getStaffList();
    }
  };

  // ---- UI-only helper: initials for the avatar chip (no logic change) ----
  const getInitials = (name = "") =>
    name
      .trim()
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((n) => n[0]?.toUpperCase())
      .join("") || "?";

  const Actions = ({ item, handleAttendance }) => {
    const last = item?.attendances?.[0];
    let type = "in";
    if (last) {
      if (last.check_in == "1" && last.check_out == "2") {
        type = "out";
      } else if (last.check_in == "1" && last.check_out == "1") {
        type = "in";
      }
    }

    const showTimePrompt = async () => {
      const now = new Date();
      const formatted =
        now.getFullYear() +
        "-" +
        String(now.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getDate()).padStart(2, "0") +
        "T" +
        String(now.getHours()).padStart(2, "0") +
        ":" +
        String(now.getMinutes()).padStart(2, "0");

      const { value: datetime } = await Swal.fire({
        title: `Enter ${type?.toUpperCase()} Time`,
        input: "datetime-local",
        inputValue: formatted,
        inputAttributes: {
          required: true,
        },
        confirmButtonText: "Submit",
        showCancelButton: true,
        cancelButtonText: "Cancel",
      });

      if (!datetime) return;
      handleAttendance(item.registration_no, datetime);
    };

    return (
      <>
        {type ? (
          <button
            className={`btn btn-sm text-capitalize d-inline-flex align-items-center gap-1 ${
              type === "out" ? "btn-outline-danger" : "btn-outline-primary"
            }`}
            onClick={showTimePrompt}
          >
            <i
              className={`bx ${type === "out" ? "bx-log-out-circle" : "bx-log-in-circle"}`}
            ></i>
            Check {type}
          </button>
        ) : (
          <button
            className="btn btn-sm btn-label-secondary d-inline-flex align-items-center gap-1"
            disabled
          >
            <i className="bx bx-check-circle"></i>
            Attendance Done
          </button>
        )}
      </>
    );
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <HostelHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <WelcomeBar />

                <div className="card mb-3 shadow-sm">
                  <div className="card-body">
                    <div className="row g-3 align-items-center">
                      <div className="col">
                        <h4 className="mb-0 d-flex align-items-center gap-2">
                          <i className="bx bx-user-check text-primary"></i>
                          Student Attendance
                        </h4>
                        <small className="text-muted">
                          Mark daily check-in / check-out for hostel students
                        </small>
                      </div>
                      <div className="col-auto text-end">
                        <Link
                          to={"/hostel/student/attendance/list/monthly"}
                          className="btn btn-label-primary d-inline-flex align-items-center gap-1"
                        >
                          <i className="bx bx-calendar"></i>
                          Attendance List
                        </Link>
                      </div>
                    </div>
                    <hr />
                    <div className="row g-2">
                      <div className="col-md-4 col-sm-6">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="date"
                            className="form-control"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                          />
                          <label htmlFor="">Date</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card shadow-sm">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">Students</h6>
                    <span className="badge bg-label-primary rounded-pill">
                      {data?.length ?? 0} record{data?.length === 1 ? "" : "s"}
                    </span>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover align-middle text-center mb-0">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "60px" }}>#</th>
                            <th className="text-start">Name</th>
                            <th>Mobile</th>
                            <th className="text-start">Address</th>
                            <th>Date</th>
                            <th style={{ width: "160px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.length > 0
                            ? data.map((item, i) => (
                                <tr key={i}>
                                  <td className="text-muted">{i + 1}</td>
                                  <td className="text-start">
                                    <div className="d-flex align-items-center gap-2">
                                      <span
                                        className="avatar-initial rounded-circle bg-label-primary d-flex align-items-center justify-content-center fw-semibold"
                                        style={{
                                          width: 32,
                                          height: 32,
                                          fontSize: "0.75rem",
                                        }}
                                      >
                                        {getInitials(item?.student_name)}
                                      </span>
                                      <div className="d-flex flex-column text-start">
                                        <span className="fw-medium">
                                          {item?.student_name}
                                        </span>
                                        <small className="text-muted">
                                          {item?.registration_no}
                                        </small>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    {item?.mobile ? (
                                      <a
                                        href={`tel:${item.mobile}`}
                                        className="text-body text-decoration-none"
                                      >
                                        <i className="bx bx-phone me-1 text-muted"></i>
                                        {item.mobile}
                                      </a>
                                    ) : (
                                      <span className="text-muted">—</span>
                                    )}
                                  </td>
                                  <td
                                    className="text-start text-truncate"
                                    style={{ maxWidth: "220px" }}
                                    title={item?.address}
                                  >
                                    {item?.address || (
                                      <span className="text-muted">—</span>
                                    )}
                                  </td>
                                  <td>
                                    <span className="badge bg-label-secondary">
                                      {formatToDate(date)}
                                    </span>
                                  </td>
                                  <td>
                                    {hasAccess("/hostel/student/attendance") && (
                                    <Actions
                                      item={item}
                                      handleAttendance={handleAttendance}
                                    />
                                    )}
                                  </td>
                                </tr>
                              ))
                            : !loading && (
                                <tr>
                                  <td colSpan={6} className="py-5 text-muted">
                                    <i className="bx bx-calendar-x fs-1 d-block mb-2"></i>
                                    No attendance records found for this date.
                                  </td>
                                </tr>
                              )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
